const { createEventGA4 } = require('./eventGA4');

/**
 * @typedef {object} AbstractCustomEventGA4
 * @property {string} [eventga4_parameter_1_name] - The name of the first param
 * @property {string} [eventga4_parameter_1_value] - The value of the first param
 * @property {string} [eventga4_parameter_2_name] - The name of the second param
 * @property {string} [eventga4_parameter_2_value] - The value of the second param
 * @property {string} [eventga4_parameter_3_name] - The name of the third param
 * @property {string} [eventga4_parameter_3_value] - The value of the third param
 * @property {string} [eventga4_parameter_4_name] - The name of the fourth param
 * @property {string} [eventga4_parameter_4_value] - The value of the fourth param
 * @property {string} [eventga4_parameter_5_name] - The name of the fifth param
 * @property {string} [eventga4_parameter_5_value] - The value of the fifth param
 */

/**
 * Custom Event for Google Analytics 4.
 * It can contain a maximum of five params. Empty params has an empty string as
 * name and value.
 * @typedef {import('./eventGA4').EventGA4 & AbstractCustomEventGA4} CustomEventGA4
 */

/**
 *
 * @param {string} name The name of the event
 * @param {Array.<[string, string]>} [params] Array of the params. Each param is
 * an array of [name, value].
 * @returns {CustomEventGA4} object with all the params that are needed
 */
function createCustomEventGA4(name, params = []) {
  const emptyName = '';
  const emptyValue = '';
  /**
   * @type {Array.<[string, string]>}
   * Array with a length of five. Empty params are included as ['', '']
   */
  const safeParams = Array.from({ length: 5 }, (_, i) => {
    if (params.length > i && params[i].length === 2) {
      return [params[i][0], params[i][1] ?? emptyValue];
    }
    return [emptyName, emptyValue];
  });

  return createEventGA4('eventga4', name, {
    eventga4_parameter_1_name: safeParams[0][0],
    eventga4_parameter_1_value: safeParams[0][1],
    eventga4_parameter_2_name: safeParams[1][0],
    eventga4_parameter_2_value: safeParams[1][1],
    eventga4_parameter_3_name: safeParams[2][0],
    eventga4_parameter_3_value: safeParams[2][1],
    eventga4_parameter_4_name: safeParams[3][0],
    eventga4_parameter_4_value: safeParams[3][1],
    eventga4_parameter_5_name: safeParams[4][0],
    eventga4_parameter_5_value: safeParams[4][1],
  });
}

module.exports = {
  createCustomEventGA4,
};
